import { Fragment } from 'react';
import {
    Icon,
    cssVar,
    Box,
    Text,
    Popover,
    PopoverTrigger,
    PopoverContent,
    DataList,
    DataItem,
} from '@cad-arc';
import { RelatedDataEntity } from '@mark43/cad-api';
import { formatDate } from '../../../../common/helpers/utils';

export const MatchingCriteriaPopover = ({ cadEvent }: { cadEvent: RelatedDataEntity }) => {
    const { location, persons, phoneNumbers, vehicles } =
        cadEvent.relatedDataMatchingCriteria ?? {};

    if (
        location === undefined &&
        (persons === undefined || persons?.length === 0) &&
        (phoneNumbers === undefined || phoneNumbers?.length === 0) &&
        (vehicles === undefined || vehicles?.length === 0)
    ) {
        return <></>;
    }

    const phoneNumbersString = phoneNumbers?.join(', ');

    return (
        <Popover>
            <PopoverTrigger asChild>
                <Icon
                    icon="Information"
                    aria-label="matching criteria"
                    style={{ color: cssVar('arc.colors.brand.default'), cursor: 'pointer' }}
                    data-testid="MATCHING_CRITERIA_POPOVER_TRIGGER"
                />
            </PopoverTrigger>
            <PopoverContent>
                <Text variant="headingXs">Matching Criteria</Text>
                <Box
                    fontSize="sm"
                    marginTop="3"
                    maxWidth={268}
                    data-testid="MATCHING_CRITERIA_POPOVER_CONTENT"
                >
                    <DataList variant="inline" spacing="1">
                        {location && <DataItem dataKey="Location">{location}</DataItem>}

                        {phoneNumbersString && (
                            <DataItem dataKey="Phone Number">{phoneNumbersString}</DataItem>
                        )}

                        {vehicles?.map((vehicle, index) => {
                            const { vehiclePlate, state, vin } = vehicle;

                            return (
                                <Fragment key={index}>
                                    {(vehiclePlate || state || vin) && (
                                        <Box paddingTop="3">
                                            <Text variant="headingXs" fontWeight="normal">
                                                Vehicle Info
                                            </Text>
                                        </Box>
                                    )}
                                    {vehiclePlate && (
                                        <DataItem dataKey="Vehicle Plate">{vehiclePlate}</DataItem>
                                    )}
                                    {state && <DataItem dataKey="Vehicle State">{state}</DataItem>}
                                    {vin && <DataItem dataKey="Vehicle VIN">{vin}</DataItem>}
                                </Fragment>
                            );
                        })}

                        {persons?.map((person, index) => {
                            const { name, involvement, dateOfBirth, driversLicenseNumber } = person;

                            return (
                                <Fragment key={index}>
                                    {(name ||
                                        involvement ||
                                        dateOfBirth ||
                                        driversLicenseNumber) && (
                                        <Box paddingTop="3">
                                            <Text variant="headingXs" fontWeight="normal">
                                                Person Info
                                            </Text>
                                        </Box>
                                    )}
                                    {name && <DataItem dataKey="Name">{name}</DataItem>}
                                    {involvement && (
                                        <DataItem dataKey="Involvement">{involvement}</DataItem>
                                    )}
                                    {dateOfBirth && (
                                        <DataItem dataKey="DOB">{formatDate(dateOfBirth)}</DataItem>
                                    )}
                                    {driversLicenseNumber && (
                                        <DataItem dataKey="DL">{driversLicenseNumber}</DataItem>
                                    )}
                                </Fragment>
                            );
                        })}
                    </DataList>
                </Box>
            </PopoverContent>
        </Popover>
    );
};
